import { For } from "solid-js";
import { Button, Surface } from "@sn/snkit";

const modules = [
  { label: "Feed", status: "planned", value: "social graph" },
  { label: "Messenger", status: "planned", value: "realtime" },
  { label: "Marketplace", status: "planned", value: "listings" },
  { label: "Wallet", status: "later", value: "ledger" },
];

export function App() {
  return (
    <main class="portal-shell">
      <aside class="portal-sidebar" aria-label="Primary">
        <a class="portal-brand" href="/">
          <span class="portal-brand__mark">SN</span>
          <span class="portal-brand__name">Portal</span>
        </a>
        <nav class="portal-nav">
          <a aria-current="page" href="/">
            Overview
          </a>
          <a href="/feed">Feed</a>
          <a href="/im">Messenger</a>
          <a href="/marketplace">Marketplace</a>
        </nav>
      </aside>

      <section class="portal-content">
        <div class="portal-topbar">
          <div>
            <p class="portal-eyebrow">Cloudflare Pages ready</p>
            <h1>Перший frontend deployment slice</h1>
          </div>
          <Button tone="quiet">Open status</Button>
        </div>

        <Surface class="portal-board">
          <div class="portal-board__header">
            <div>
              <p class="portal-eyebrow">Monorepo</p>
              <h2>apps/web/portal + packages/snkit</h2>
            </div>
            <Button>Deploy preview</Button>
          </div>
          <div class="portal-grid">
            <For each={modules}>
              {(item) => (
                <article class="portal-module">
                  <span class="portal-module__status">{item.status}</span>
                  <h3>{item.label}</h3>
                  <p>{item.value}</p>
                </article>
              )}
            </For>
          </div>
        </Surface>
      </section>
    </main>
  );
}
